export default __webpack_public_path__ + "static/media/barco-foto-noche.7774c304.jpeg";